import {PATH} from '@/routes';

interface RedirectToQuizFunctionArgs {
  readonly from?: string;
}

interface RedirectToQuizFunction {
  (args: RedirectToQuizFunctionArgs): void;
}

export const redirectToQuiz: RedirectToQuizFunction = ({from}) => {
  window.location.href = `${PATH.QUIZ}${from ? `#${encodeURIComponent(`usfFrom=${from}`)}` : ''}`;
};
